// SPDX-License-Identifier: AGPL-3.0-or-later

import {ExternalE2EEKeyProvider, type Room} from '@app/parley/rtc';

const roomE2EEWorkers = new WeakMap<Room, Worker>();

// parley: MoQ media is encrypted on the main thread with WebCrypto
// (parley/rtc/e2ee.ts), so there is no LiveKit E2EE worker.
export function createE2EEWorker(): Worker | null {
	return null;
}

export function createE2EEKeyProvider(): ExternalE2EEKeyProvider {
	return new ExternalE2EEKeyProvider();
}

export function ownE2EEWorker(room: Room, worker: Worker | null): void {
	if (worker === null) return;
	const previous = roomE2EEWorkers.get(room) ?? null;
	if (previous !== null && previous !== worker) previous.terminate();
	roomE2EEWorkers.set(room, worker);
}

export function releaseE2EEWorker(room: Room | null): boolean {
	if (room === null) return false;
	const worker = roomE2EEWorkers.get(room) ?? null;
	if (worker === null) return false;
	roomE2EEWorkers.delete(room);
	worker.terminate();
	return true;
}
